import React from "react";
import {
    Chip,
    Typography,
} from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { previewFromURL } from "@icarius-utils/download";
import { RESOURCES_ENDPOINT } from "@icarius-connection/endpoints";
import Container from "../../../container";
import { GetAppIcon } from "@icarius-icons/index";
import { ACTIVITY_STATUS_OPTIONS } from "@icarius-pages/myTraining/constants";

const DescriptionTab = (props) => {

    const {
        trainingData,
        activityData,
    } = props;

    return (
        <Container style={{ flex: 1 }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                }}
            >
                <Typography style={{ fontSize: 18, fontWeight: 600 }}>
                    {activityData.name}
                </Typography>
                <Chip
                    size="small"
                    label={activityData.typeString}
                    style={{
                        border: "1px solid var(--borderColor)",
                    }}
                />
                {
                    activityData.status === ACTIVITY_STATUS_OPTIONS.completed && trainingData.isParticipant &&
                    <Chip
                        size="small"
                        style={{
                            background: "var(--ownGreen)",
                            color: "white",
                        }}
                        label={getLocalizedString("complete")}
                    />
                }
            </div>
            <Typography style={{ marginTop: 5, fontSize: 14 }}>
                <span style={{ textDecoration: "underline" }}>{getLocalizedString("instructor")}</span>: {trainingData.instructor}
            </Typography>
            <div
                style={{
                    marginTop: 15,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                }}
            >
                <Typography>
                    {trainingData.description}
                </Typography>
                <Typography variant="caption">
                    {getLocalizedString("length")}: {activityData.length} {getLocalizedString("hrs")}
                </Typography>
                {
                    Boolean(activityData.resources.length) &&
                    <div style={{ padding: "6px 0px", display: "flex", flexDirection: "column", gap: 4 }}>
                        {
                            activityData.resources?.map((resource, resourceIndex) => {
                                return (
                                    <Chip
                                        key={resourceIndex}
                                        onClick={() => previewFromURL(RESOURCES_ENDPOINT + resource.path)}
                                        style={{
                                            border: "1px solid var(--borderColor)",
                                            cursor: "pointer",
                                        }}
                                        label={resource.name}
                                        icon={<GetAppIcon />}
                                    />
                                )
                            })
                        }
                    </div>
                }
            </div>
        </Container>
    )
}

export default DescriptionTab;